import { useAtom }                 from "jotai";
import { notificationQRPopupAtom } from "_jotai/notifications";
import Presentation                from "./presentation";

const component =  ( { notificationQRPopup } ) => {

	const [ , setNotificationQRPopup ] = useAtom ( notificationQRPopupAtom );

	const handleClose = () => {
		setNotificationQRPopup ( false );

	};

	return (
		<Presentation
			handleClose = { handleClose }
			open        = { notificationQRPopup }
		/>

	);
};

export default component;
